import type { UserManagerSettings } from 'oidc-client-ts';

const region = import.meta.env.VITE_AWS_REGION as string;
const userPoolId = import.meta.env.VITE_USER_POOL_ID as string;
const clientId = import.meta.env.VITE_USER_POOL_CLIENT_ID as string;
const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN as string;

// IMPORTANT: do NOT set `metadataUrl: https://<hosted-ui-domain>/.well-known/openid-configuration`.
// The Cognito Hosted UI domain (e.g. <app>-<env>.auth.<region>.amazoncognito.com) only serves
// the login UI — it does NOT expose the OIDC discovery document. Setting metadataUrl to that
// host causes a silent 404, oidc-client-ts hangs on signinRedirect, and the SPA shows a
// perpetual loading spinner. Set `authority` (the cognito-idp URL) only — oidc-client-ts will
// fetch metadata from `<authority>/.well-known/openid-configuration` automatically.
export const oidcConfig: UserManagerSettings = {
  authority: `https://cognito-idp.${region}.amazonaws.com/${userPoolId}`,
  client_id: clientId,
  redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid email profile',
  loadUserInfo: true,
  automaticSilentRenew: true,
};

export const cognitoSignOutUrl = (idToken?: string) => {
  const params = new URLSearchParams({
    client_id: clientId,
    logout_uri: window.location.origin,
  });
  if (idToken) params.set('id_token_hint', idToken);
  return `https://${cognitoDomain}/logout?${params.toString()}`;
};
